var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcContent',{staticClass:"forms-emptycontent",attrs:{"app-name":"forms"}},[_c('NcEmptyContent',{attrs:{"title":_vm.currentModel.title,"description":_vm.currentModel.description},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_vm.currentModel.icon,{tag:"Icon",attrs:{"size":64}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }